// Frontend payment API helpers

async function parseError(response) {
  try {
    const data = await response.json();
    return data.detail || data.error || `Request failed (${response.status})`;
  } catch {
    return `Request failed (${response.status})`;
  }
}

export async function createOrder({ email, registration, brand, totalPence, items, vehicle }) {
  const response = await fetch("/api/orders", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      email,
      registration,
      brand,
      total_pence: totalPence,
      items,
      vehicle,
    }),
  });
  if (!response.ok) throw new Error(await parseError(response));
  return response.json();
}

export async function createPaymentIntent(orderId) {
  const response = await fetch("/api/payments/intent", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ order_id: orderId }),
  });
  if (!response.ok) throw new Error(await parseError(response));
  return response.json();
}

export async function getStripePublishableKey() {
  const response = await fetch("/api/payments/config");
  if (!response.ok) throw new Error(await parseError(response));
  const data = await response.json();
  return data.publishable_key || import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || "";
}

export async function confirmPayment(orderId, paymentIntentId) {
  const response = await fetch("/api/payments/confirm", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ order_id: orderId, payment_intent_id: paymentIntentId }),
  });
  if (!response.ok) throw new Error(await parseError(response));
  return response.json();
}
